import * as Types from '../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetUniversalBurgerMenuDataQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetUniversalBurgerMenuDataQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: { __typename?: 'EventInfo'; id: string; location?: string | null; tentativeDate?: { __typename?: 'Date'; timestamp: any } | null };
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    pages: Array<{ __typename?: 'EventPage'; visibility: Types.EventPageVisibility; pageSlug: string; id: string; type: Types.EventPageType; pageTitle: string }>;
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
  } | null;
};

export const GetUniversalBurgerMenuDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUniversalBurgerMenuData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tentativeDate' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productVerticals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUniversalBurgerMenuDataQuery__
 *
 * To run a query within a React component, call `useGetUniversalBurgerMenuDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversalBurgerMenuDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversalBurgerMenuDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetUniversalBurgerMenuDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>(GetUniversalBurgerMenuDataDocument, baseOptions);
}
export function useGetUniversalBurgerMenuDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>(GetUniversalBurgerMenuDataDocument, baseOptions);
}
export type GetUniversalBurgerMenuDataQueryHookResult = ReturnType<typeof useGetUniversalBurgerMenuDataQuery>;
export type GetUniversalBurgerMenuDataLazyQueryHookResult = ReturnType<typeof useGetUniversalBurgerMenuDataLazyQuery>;
export type GetUniversalBurgerMenuDataQueryResult = Apollo.QueryResult<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>;
